import { useDispatch } from "react-redux";
import { useUploader } from "../useUploader";
import { reset, setImages } from "store/features/bulkResize/actions";
import { getRandomId } from "client/utils/getRandomId";
import { formatBytes } from "client/utils/formatBytes";
import { ImageExtension } from "store/types/imageExtension";
import { ga } from "client/utils/adsense/ga";
import { gtag } from "client/utils/adsense/gtag";
import { useRouter } from "next/router";
import { getFCUrl } from "client/utils/getFCUrl";
import { getUrlExtension } from "client/utils/getUrlExtension";
import translatedRoutedSlugs, { type TranslatedRouteSlugs } from "translatedRouteSlugs";
import { getFileNameFromTask } from "client/utils/getFileNameFromTask";
import { getFileExtFromTask } from "client/utils/getFileExtFromTask";

export const useBulkResizeUploader = () => {
    const dispatch = useDispatch();
    const router = useRouter();

    const handleProceed = () => {
        dispatch(reset());
        dispatch(
            setImages(
                images.map((image) => {
                    const size = formatBytes(image.task?.result?.size ?? 0);
                    return {
                        id: getRandomId(),
                        original: {
                            height: 0,
                            width: 0,
                            size,
                        },
                        preview: {
                            height: 0,
                            width: 0,
                            size,
                        },
                        src:
                            image.upload.type === "device"
                                ? getFCUrl(image.file.src ?? image.task?.result?.url?.toString())
                                : getFCUrl(image.task?.result?.url?.toString() || image.file.src),
                        title: image.file?.file.name ?? (image.task ? getFileNameFromTask(image.task) : "") ?? "",
                        format:
                            "." + ((`${image.task ? getFileExtFromTask(image.task) : ""}` as ImageExtension) ?? "jpg"),
                        createdAt: new Date(),
                        importTask: image.task ?? undefined,
                        state: "imported",
                        uploadType: image.upload.type,
                        settings: image.upload.settings,
                        fileData: image.file,
                        ext: getUrlExtension(image.task?.result?.url?.toString() ?? ""),
                    };
                }),
            ),
        );

        router.push(
            "/" +
                translatedRoutedSlugs["/bulk-resize/editor"][
                    (router.locale as keyof TranslatedRouteSlugs["/bulk-resize"]) ?? "en"
                ] ?? "/bulk-resize/editor",
        );
    };

    const handleFirstImageLoadedAnalytics = () => {
        ga("send", {
            hitType: "pageview",
            page: "/vp/bulk_resizer/image_loaded/",
            title: "Bulk Resizer Image Loaded",
        });

        ///event
        gtag("event", "Image Loaded", {
            event_category: "Bulk Resizer",
            event_label: "Upload Page",
        });
    };

    const { images, deleteImage, deleteAllImages } = useUploader(handleProceed, handleFirstImageLoadedAnalytics);

    return { deleteImage, deleteAllImages };
};
